import React from 'react'
import { useIsSmallScreen } from '~/hooks'
import { AuthTemplateView, Bold } from '~/components'
import { ArrowRightIcon, CheckIcon } from '~/assets/icons'
import { Box, Button, Typography } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'

export const SuccessfulResetPassword: React.FC = () => {
  const isSmallScreen = useIsSmallScreen()

  return (
    <AuthTemplateView>
      <CheckIcon
        htmlColor={mutualTheme.palette.secondary.dark}
        sx={{
          fontSize: 66
        }}
      />

      <Typography
        variant={isSmallScreen ? 'airbnbH2' : 'airbnbH1'}
        sx={{ marginBottom: 1 }}
      >
        Sucesso!
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography variant={isSmallScreen ? 'airbnbBody2' : 'airbnbBody1'}>
          Sua nova senha foi definida com sucesso.
        </Typography>

        <Typography variant={isSmallScreen ? 'airbnbBody2' : 'airbnbBody1'}>
          Você já pode entrar na sua conta utilizando sua <Bold>nova senha</Bold>.
        </Typography>
      </Box>

      <Button
        href='/'
        variant='contained'
        type='submit'
        color='primary'
        size='large'
        endIcon={<ArrowRightIcon htmlColor='inherit' />}
        sx={{
          width: '200px',
          height: 56,
          marginTop: 4,
          fontWeight: 700
        }}
      >
        Voltar ao login
      </Button>
    </AuthTemplateView >
  )
}
